module.exports = __webpack_public_path__ + "media/KikiMiraculous.cbea32a5.mp3";